export const SET_LOADING_PROGRESS = 'SET_LOADING_PROGRESS';